import { render, staticRenderFns } from "./setOtherAccount.vue?vue&type=template&id=e837eaf4&"
import script from "./setOtherAccount.vue?vue&type=script&lang=js&"
export * from "./setOtherAccount.vue?vue&type=script&lang=js&"
import style0 from "./setOtherAccount.vue?vue&type=style&index=0&id=e837eaf4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports